var map = {
	"./1.png": "5e23",
	"./2.png": "151e",
	"./3.png": "23d5",
	"./4.png": "2160",
	"./5.png": "ebe2",
	"./6.png": "bce6",
	"./7.png": "4edd",
	"./8.png": "899a",
	"./9.png": "2a1a",
	"./applyCount.png": "242e",
	"./enrolment.png": "0cd8",
	"./studentCount.png": "aacd",
	"./top9-left.png": "dc22",
	"./top9-right.png": "dd0f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "18de";